export default __webpack_public_path__ + "static/756-806614fcce3e39358ee6b47bd3c6344f.gif";